type TrimCanvasOptions = {
  paddingPx?: number;
};

export function trimCanvas(
  source: HTMLCanvasElement,
  { paddingPx = 8 }: TrimCanvasOptions = {},
): HTMLCanvasElement {
  const w = source.width;
  const h = source.height;
  if (w <= 0 || h <= 0) return source;

  const ctx = source.getContext('2d');
  if (!ctx) return source;

  const { data } = ctx.getImageData(0, 0, w, h);

  let minX = w;
  let minY = h;
  let maxX = -1;
  let maxY = -1;

  // Consider any non-transparent pixel as "ink".
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const i = (y * w + x) * 4;
      const a = data[i + 3];
      if (a > 0) {
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      }
    }
  }

  // No ink found; return original canvas.
  if (maxX < 0 || maxY < 0) return source;

  const inkW = maxX - minX + 1;
  const inkH = maxY - minY + 1;

  const pad = Math.max(0, Math.floor(paddingPx));
  const out = document.createElement('canvas');
  out.width = inkW + pad * 2;
  out.height = inkH + pad * 2;

  const outCtx = out.getContext('2d');
  if (!outCtx) return source;

  outCtx.drawImage(
    source,
    minX,
    minY,
    inkW,
    inkH,
    pad,
    pad,
    inkW,
    inkH,
  );

  return out;
}

